import { FC } from "react";
import CustomButton from "ui/Button";
import { DATE_FORMAT, ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import { FilterOption } from "interface";
import { addDays } from "date-fns";
import DatePickerComponent from "ui/Date";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: FilterOption) => void;
	filterOptions: FilterOption;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	exportAsPDF,
	...props
}) => {
	const { t } = useTranslation();

	return (
		<div className="filter-container">
			<div className="filter-items frozen-sales-filter-items">
				<div className="frozen-sales-filter-field" style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("FromDate")}
						label={t("FromDate")}
						className="height-inherit"
						style={{ width: "100%" }}
						format={DATE_FORMAT}
						value={filterOptions.fromDate}
						max={new Date()}
						// min={addDays(new Date(), -21)}
						onChange={(e) =>
							setFilterOptions({
								...filterOptions,
								fromDate: e.target.value,
								take: props.pageSize,
								skip: 0,
							})
						}
					/>
				</div>
				<div className="frozen-sales-filter-field" style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("ToDate")}
						label={t("ToDate")}
						className="height-inherit"
						style={{ width: "100%" }}
						format={DATE_FORMAT}
						value={filterOptions.toDate}
						max={new Date()}
						min={addDays(new Date(), -21)}
						onChange={(e) =>
							setFilterOptions({
								...filterOptions,
								toDate: e.target.value,
								take: props.pageSize,
								skip: 0,
							})
						}
					/>
				</div>

				{/* <div style={{ width: "170px" }}>
					<CustomDropDownList
						onSelect={(buyer: Buyer) =>
							setFilterOptions({
								...filterOptions,
								buyerId: buyer.id as any,
								buyerName: buyer.name,
								buyerLedgerNumber: buyer.id as any,
								take: props.pageSize,
								skip: 0,
							})
						}
						data={[]}
						value={{
							id: filterOptions.buyerId || null,
							displayName: filterOptions.buyerName || t("ChooseBuyer"),
						}}
						dataItemKey="id"
						textField="displayName"
						label={t("Buyer")}
						defaultItem={{ id: "id", displayName: t("All") }}
						className="height-inherit"
						filterable={true}
						serverFilter={true}
						serverFilterApi={getBuyersFilterApi}
					/>
				</div> */}
			</div>

			<div className="filter-end-btn frozen-sales-filter-end-btn">
				<CustomButton
					label={"PDF"}
					onClick={() => exportAsPDF()}
					iconName={ICON_NAMES.Download}
				/>
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
